<app-base-list [listTitle]="'PARTNER.CONTACT.TITLE' | transloco" [hideTitle]="hideTitle">
  <app-item-list *ngIf="partner.phoneNumber" [href]="'tel:'+partner.phoneNumber" iconPath="assets/icons/phone.svg"
    [iconColor]="IonicColorEnum.PRIMARY" [title]="partner.phoneNumber"
    [subtitle]="'PARTNER.CONTACT.PHONE_CALL' | transloco"/>
  <app-item-list *ngIf="partner.whatsAppNumber" [href]="'https://wa.me/' + partner.whatsAppNumber" iconPath="assets/icons/message.svg"
    [iconColor]="IonicColorEnum.PRIMARY"
    [title]="partner.phoneNumber ?? ''" [subtitle]="'PARTNER.CONTACT.WHATSAPP' | transloco"/>
  <app-item-list *ngIf="partner.textNumber" [href]="'sms:' + partner.textNumber" iconPath="assets/icons/message.svg"
    [iconColor]="IonicColorEnum.PRIMARY"
    [title]="partner.phoneNumber ?? ''" [subtitle]="'PARTNER.CONTACT.TEXT_MESSAGE' | transloco"/>
  <app-item-list [href]="'mailto:' + partner.email" iconPath="assets/icons/mail.svg"
    [iconColor]="IonicColorEnum.PRIMARY"
    [title]="partner.email" [subtitle]="'PARTNER.CONTACT.MAIL' | transloco"/>
</app-base-list>